import React from "react";
import {Box, Container, Typography} from "@material-ui/core/";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Grid from "@material-ui/core/Grid";
import Meta from "../components/Meta";
import StoryControl from "../components/StoryControl";
// do not delete this line or you will get tsx compile error
declare global {
    interface Window {
        analytics: any;
    }
}


function Browse({
                    storyId,
                    readOnly = false,
                    description,
                    title
                }: {
    storyId?: string,
    readOnly?: boolean,
    description?: string,
    title?: string
}) {
    return (
        <Box>
            <Meta description={description}
                  title={title}
            />
            <Container maxWidth={'sm'}>
                <Box mb={2}>
                    <Grid container spacing={1} justify="center">
                        <Grid item>
                            <Typography variant={'h3'} align={'center'}> Dive into a Fantasy </Typography>

                        </Grid>
                        <Grid item>
                            <Typography align={'center'}> Browse stories made public by others </Typography>
                        </Grid>

                    </Grid>
                </Box>

                <StoryControl/>

            </Container>
        </Box>)
}


export default Browse
// export story as a global variable
